import { render } from "./RegionPicker.vue?vue&type=template&id=2ed50a4c"
import script from "./RegionPicker.vue?vue&type=script&lang=js"
export * from "./RegionPicker.vue?vue&type=script&lang=js"
script.render = render

export default script